import { render, staticRenderFns } from "./PublicAccessEdit.vue?vue&type=template&id=226f4570"
import script from "./PublicAccessEdit.vue?vue&type=script&lang=js"
export * from "./PublicAccessEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports